module.exports = __webpack_public_path__ + "img/deezer.fa4204b3.svg";